const gerar_arquivo_texto_de_docentes_com_cpf = [
  {
    path: "/gerar-arquivo-texto-de-docentes-com-cpf",
    name: "gerar_arquivo_texto_de_docentes_com_cpf",
    meta: {
      breadCrumb:
        "Censo Escolar - Relatório de Acompanhamento do Censo Escolar",
      allowedPermissions: ["relatorios_gerar_arquivo_docente"],
    },
    component: () =>
      import(
        "@/views/GerarArquivoTextoDeDocentesComCPF/GerarArquivoTextoDeDocentesComCPF.vue"
      ),
  },
];

export { gerar_arquivo_texto_de_docentes_com_cpf };
